import React, { useEffect, useRef, useState } from 'react';

import ResetAppCache from '@/components/shared/ResetAppCache/ResetAppCache';

import BooksList from './List';

interface Props {
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  searchKeyword: string;
  setSearchKeyword: (val: string) => void;
  type: 'books' | 'courses';
}

const BooksListWrapper = ({
  handleInputChange,
  searchKeyword,
  setSearchKeyword,
  type,
}: Props) => {
  const [isBlank, setIsBlank] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      const div = wrapperRef.current;
      if (div && div.innerText.trim().length < 10 && div.clientHeight < 200) {
        setIsBlank(true);
      }
    }, 1000);

    return () => clearTimeout(timeout);
  }, [searchKeyword]);

  if (isBlank) return <ResetAppCache />;

  return (
    <div ref={wrapperRef}>
      <BooksList
        handleInputChange={handleInputChange}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        type={type}
      />
    </div>
  );
};

export default BooksListWrapper;
